import { useNavigate } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useNavigation } from 'modules/core/hooks/useNavigation'

import Exports from 'modules/attendance/components/ClockIn/Modals/Exports'
import { useAttendanceDateNavigator } from 'modules/attendance/lib/attendanceDateNavigatorContext'

const EmployeePeriodExportsModalPage = () => {
  const { navigation } = useNavigation()
  const navigate = useNavigate()
  const { employee } = useCurrentSession()
  const { pathParams } = useAttendanceDateNavigator()

  const onClose = () => {
    navigate(navigation.clockIn.periodTypeYearMonthDay.fullPath(pathParams))
  }

  return <Exports employeeId={Number(employee?.id)} onClose={onClose} />
}

export default EmployeePeriodExportsModalPage
